import axios from 'axios';
import { API_ENDPOINT } from './api';
import { ReadObject } from './storage';

/**
 * Manda o áudio gravado para o NOSSO servidor transcrever.
 *
 * Antes o navegador falava direto com o Groq, levando a chave dentro do
 * pacote público do site — qualquer visitante conseguia copiá-la. Agora só
 * o servidor conhece a chave; daqui vai apenas o áudio e o login da pessoa.
 *
 * @param {Blob} blob áudio gravado
 * @returns {Promise<string>} o texto transcrito
 */
export const TranscreverAudio = async (blob) => {
    if (!blob || !blob.size) {
        throw new Error('Áudio vazio.');
    }

    let nomeArquivo = 'audio.wav';
    if (blob.type.includes('webm')) nomeArquivo = 'audio.webm';
    else if (blob.type.includes('mp4')) nomeArquivo = 'audio.mp4';
    else if (blob.type.includes('ogg')) nomeArquivo = 'audio.ogg';

    const formData = new FormData();
    formData.append('file', blob, nomeArquivo);

    const autenticacao = await ReadObject('authentication');
    if (!autenticacao?.jwt) {
        throw new Error('Você precisa estar logado para enviar áudio.');
    }

    const resposta = await axios.post(`${API_ENDPOINT}/transcrever`, formData, {
        headers: { Authorization: `Bearer ${autenticacao.jwt}` },
        timeout: 120000,
    });

    const texto = resposta?.data?.text;
    if (typeof texto !== 'string') {
        throw new Error('Não consegui entender o áudio.');
    }
    return texto;
};
